export default __webpack_public_path__ + "static/media/userguide_pt-BR.12f9e664.pdf";